import React from 'react';
import Uganda1_mature_entry_subjects from './uganda1_mature_entry_subjects';

const Uganda1_mature_entry = () => {
  return (
    <div>
      <Uganda1_mature_entry_subjects />
    </div>
  );
}

export default Uganda1_mature_entry;
